import { ThemeProvider } from "@mui/material";
import AppRouter from "./routes";
import customTheme from "./mui/theme/theme";
import { getUserDetails } from "./utils/getUserDetails";
import { useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Cookies from "js-cookie";
import "../node_modules/@foundit/header/dist/HeaderWeb.css";
import { RecruiterDetailsResponse } from "./types";



function App() {
  const [userDetails, setUserDetails] = useState<RecruiterDetailsResponse | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  // Function to fetch user details from sessionStorage
  const fetchUserDetails = () => {
    const details = getUserDetails();
    if (details && Object.keys(details).length > 0) {
      setUserDetails(details);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const intervalId = setInterval(() => {
      if (!userDetails?.recruiter_id) {
        fetchUserDetails();
      } else {
        clearInterval(intervalId);
      }
    }, 100);
    return () => clearInterval(intervalId);
  }, [userDetails]);

  const getGtmValue = (siteContext: string | undefined): string | null => {
    switch (siteContext) {
      case "monstergulf":
        return "GTM-TGMWFHT";
      case "monstersingapore":
        return "GTM-WXW3G7";
      case "monsterthailand":
        return "GTM-W4XCF74";
      case "monsterphilippines":
        return "GTM-NCB6SR";
      case "monstervietnam":
        return "GTM-TJ7F7ZH";
      case "monstermalaysia":
        return "GTM-57CQ4N";
      case "monsterindonesia":
        return "GTM-MGZV4PL";
      case "monsterhongkong":
        return "GTM-KWGPLKK";
      case "rexmonster":
        return "GTM-NGL6ZM";
      default:
        return null;
    }
  };

  useEffect(() => {
    if (userDetails) {
      const gtmId = getGtmValue(userDetails?.site_context);
      if (gtmId) {
        const noscriptElement = document.createElement("noscript");
        const iframeElement = document.createElement("iframe");
        iframeElement.src = `https://www.googletagmanager.com/ns.html?id=${gtmId}`;
        iframeElement.height = "0";
        iframeElement.width = "0";
        iframeElement.style.display = "none";
        iframeElement.style.visibility = "hidden";
        noscriptElement.appendChild(iframeElement);
        document.body.insertBefore(noscriptElement, document.body.firstChild);

        const scriptElement = document.createElement("script");
        scriptElement.innerHTML = `
          (function(w,d,s,l,i){
            w[l]=w[l]||[];
            w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});
            var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';
            j.async=true;
            j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;
            f.parentNode.insertBefore(j,f);
          })(window,document,'script','dataLayer', '${gtmId}');
        `;
        document.head.appendChild(scriptElement);
      }
    }
  }, [userDetails?.recruiter_id]);

  useEffect(() => {
    if (!userDetails?.recruiter_id) return;
    if (typeof window === "undefined") return;
    if (typeof window.clarity !== "function") return;

    try {
      const userId = String(userDetails.recruiter_id);
      window.clarity("identify", userId);

    } catch (err) {
      console.error("Clarity identify failed", err);
    }
  }, [userDetails?.recruiter_id]);

  if (isLoading) {
    return <></>;
  }

  if (userDetails && Object.keys(userDetails).length > 0) {
    return (
      <ThemeProvider theme={customTheme}>
        <ToastContainer
          position="bottom-left"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={true}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss={false}
          draggable
          pauseOnHover
          theme="light"
        />
        <AppRouter />
      </ThemeProvider>
    );
  }

  return <></>;
}

export default App;
